class LedLogicCanvasUI {
	selectedKeyId = $state<number | null>(null);
	showLedSceneForm = $state(false);

	reset() {
		this.selectedKeyId = null;
		this.showLedSceneForm = false;
	}
}

export const ledLogicCanvasUI = new LedLogicCanvasUI();
